<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row class="justify-content-md-center">
                <b-col md="7" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Physical Information Details</p>
                    <p></p>
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="igrp1" horizontal
                            label="Identification Mark <span style='color:red'>*</span>" label-size="sm">
                            <b-form-input type="text" placeholder="Identification Mark on body" size="sm"
                               :formatter="format"  lazy-formatter v-model="form.UserPhysicalDetails.IndetificationMark"></b-form-input>
                    </b-form-group>
                    <b-form-group id="igrp2" horizontal
                            label="Height <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp2" :description="getUserData.height">
                        <b-input-group size="sm" append="cm" style="width:200px">
                            <b-form-input id="inp2"
                            type="number" :min="getUserData.minht"
                            v-model="form.UserPhysicalDetails.Height"
                            required size="sm"
                            placeholder="Height"></b-form-input>   
                        </b-input-group> 
                    </b-form-group>
                    <b-form-group id="igp3" horizontal
                            label="Weight <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp3" :description="getUserData.weight">
                        <b-input-group size="sm" append="kg" style="width:200px">
                            <b-form-input id="inp3"
                            type="number" :min="getUserData.minwt"
                            v-model="form.UserPhysicalDetails.Weight"
                            required size="sm"
                            placeholder="Weight"></b-form-input>   
                        </b-input-group>    
                    </b-form-group>
                    <b-form-group id="igp4" horizontal v-if="getUserData.gender"
                             label-size="sm" label="Chest Deflated <span style='color:red'>*</span>" label-for="inp4"
                             :description="getUserData.chestD">
                        <b-input-group size="sm" append="cm" style="width:200px">
                            <b-form-input id="inp4"
                            type="number" :min="getUserData.mincd"
                            v-model="form.UserPhysicalDetails.ChestDeflated"
                            required size="sm"
                            placeholder="Chest Deflated"></b-form-input>   
                        </b-input-group>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal v-if="getUserData.gender"
                            label="Chest Inflated <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput2" :description="getUserData.chestI">
                        <b-input-group size="sm" append="cm" style="width:200px">
                            <b-form-input id="exampleInput2"
                            type="number" :min="getUserData.minci"
                            v-model="form.UserPhysicalDetails.ChestInflated"
                            required size="sm"
                            placeholder="Chest Inflated"></b-form-input>   
                        </b-input-group>    
                    </b-form-group>
                    
                    </div>
                </b-col>

            </b-row>
            
            <b-row class="mt-2 justify-content-md-center" v-if="!getUserData.LockProfile">
                <b-col md="4" sm="12" style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col  md="4" sm="12" style="text-align:right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  name: "PhysicalDetails",
  components: { Spinner },
  data() {
    return {
      isAdrsSame: false,
      form: {
        UserPhysicalDetails: {
          Height: 160,
          Weight: 50,
          ChestDeflated: 79,
          ChestInflated: 84,
          IndetificationMark: ""
        },
        LoginID: "",
        chest: "79"
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false
    };
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.savePhysicalDetails(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    filterDistricts() {},
    filterTalukas() {}
  },
  computed: {
    getUserData() {
      let x = this.$store.getters.getUserData;
      let chestD = "Minimum normal chest should be :  79 cm";
      let chestI = "Minimum normal chest should be :  84 cm";
      let weight = "Minimum weight should be : 50kg";
      let height = "Minimum height should be : 162cm";
      let mincd = 79;
      let minci = 84;
      let minwt = 50;
      let minht = 162;

      if (x.Gender == "false") {
        x.Gender = false;
      }

      if (x.Gender == "true") {
        x.Gender = true;
      }

      if (!x.Gender) {
        chestD = "Minimum normal chest should be :  -- cm";
        chestI = "Minimum normal chest should be :  -- cm";
        weight = "Minimum weight should be : 48kg";
        height = "Minimum height should be : 155cm";
        mincd = 79;
        minci = 84;
        minwt = 48;
        minht = 155;
      }

      return {
        chestD: chestD,
        chestI: chestI,
        weight: weight,
        height: height,
        mincd: mincd,
        minci: minci,
        minwt: minwt,
        minht: minht,
        gender: x.Gender,
        LockProfile: x.LockProfile
      };
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let promise = apis.ReadUserPhysicalDetails(userinfo.UserId);

    promise
      .then(response => {
        //console.log('Physical Response' ,response);
        if (response.status == 200) {
          this.form.UserPhysicalDetails = response.body;
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/PhysicalDetails.vue